<template>
  <div class="food-manage">
    <el-form ref="createEmpolyeeForm" :model="createEmpolyeeForm" :rules="createEmpolyeeFormRule">
      <el-form-item label="部门/名称" prop="exercise_title">
        <department-select :selected.sync="createEmpolyeeForm.departmentId" filterable placeholder="请选择" />
        <el-input v-model="createEmpolyeeForm.name" placeholder="请输入" style="width: 150px;margin-left:20px" />
        <el-button type="primary" style="margin-left:20px" @click="fnGetSearchUserList()">查询</el-button>
      </el-form-item>
      <el-form-item v-if="empolyeeList.length > 0">
        <el-checkbox-group v-model="createEmpolyeeForm.uid">
          <el-checkbox v-for="item in empolyeeList" :key="item.uid" :value="item.uid" :label="item.uid">{{ item.name }}({{ item.title }})</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="奖金">
        <el-input v-model="createEmpolyeeForm.amount" placeholder="请输入金额" style="width: 150px;margin-left:20px" @input="fnSetSendPrice" />
        <span style="margin-left:20px">元</span>
        <span style="margin-left:20px">当前股价<span style="color:red">{{ currentPrice/100 }}</span>元，共计{{ createEmpolyeeForm.shareNum || 0 }}股</span>
      </el-form-item>
      <el-form-item label="类型" prop="exercise_type">
        <Select key="7" :selected.sync="createEmpolyeeForm.exerciseType" :data="stockTypes" clearable placeholder="请选择" @updateSelect="fnGetExerciseList()" />
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="createEmpolyeeForm.exerciseId">
          <el-radio v-for="item in lists" v-show="item.is_delete != 1" :key="item.exercise_id" style="margin-bottom: 20px;" :label="item.exercise_id" :value="item.exercise_id">{{ item.exercise_title }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="fnSubmitCreate">确定</el-button>
    </div>
  </div>

</template>
<script>
import DepartmentSelect from './DepartmentSelect'

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
var BigNumber = require('bignumber.js')

const defaultCreateEmpolyeeForm = {
  uid: [],
  amount: '',
  shareNum: '',
  exerciseId: '',
  exerciseType: '',
  departmentId: '',
  name: ''
}

export default {
  name: 'WaitSendStockLists',
  components: {
    Select,
    DepartmentSelect
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      departmentList: [],
      empolyeeList: [],
      stockTypes: commondata.STOCK_TYPE,
      createEmpolyeeForm: Object.assign({}, defaultCreateEmpolyeeForm),
      createEmpolyeeFormRule: {},
      currentPrice: 0
    }
  },
  created() {
    this.fnGetDepartmentList()
    this.fnGetLatestPrice()
  },
  methods: {
    fnGetLatestPrice() {
      this.$http.getLatestSharePrice().then(res => {
        this.currentPrice = parseFloat(res.data.share_price || '0')
      })
    },
    fnSetSendPrice(val) {
      const current = BigNumber(this.currentPrice / 100)
      const price = BigNumber(val || '0')
      const result = BigNumber(price.dividedBy(current)).toFixed(0)
      this.createEmpolyeeForm.shareNum = result
    },
    fnGetDepartmentList() {
      this.$http.getDepartmentList().then(res => {
        res.data.forEach((ele) => {
          ele.label = ele.name
        })
        this.departmentList = res.data
      })
    },
    fnGetSearchUserList() {
      this.$http.getUserList(this.createEmpolyeeForm).then(res => {
        this.empolyeeList = res.data
      })
    },
    fnGetExerciseList: function() {
      this.$http.getExerciseScheduleList({ exerciseType: this.createEmpolyeeForm.exerciseType, is_delete: 0 }).then(res => {
        this.lists = res.data
      })
    },
    fnSubmitCreate() {
      if (this.createEmpolyeeForm.uid.length == 0 || !this.createEmpolyeeForm.exerciseId || !this.createEmpolyeeForm.shareNum) {
        this.$message({
          type: 'error',
          message: '请填写相关信息'
        })
        return
      }
      const postForm = Object.assign({}, this.createEmpolyeeForm)
      postForm.uid = postForm.uid.join(',')
      this.$http.recordWarehouse(postForm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.createEmpolyeeForm = {}
          this.createEmpolyeeForm = Object.assign({}, defaultCreateEmpolyeeForm)
          this.$emit('successCBK')
        }
      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
